module.exports = __webpack_public_path__ + "static/media/Logo and Color Guide_1739383371659.19ab4d6f.pdf";